import React from "react";

/**
 * ErrorBoundary catches runtime errors in its child component tree
 * and renders a fallback UI instead of crashing the app.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  // React lifecycle: called if a child throws during rendering
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  // Useful for logging errors (e.g., send to server)
  componentDidCatch(error, errorInfo) {
    // Keep your console log if you want
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "20px", color: "red" }}>
          <h2>Something went wrong.</h2>
          <pre>{this.state.error?.toString()}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
